import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useNavigate, useParams } from "react-router-dom";
import axiosinstances from "../../../Helper/useAxios";
import "../product.css";

export default function CreateNewProduct({
  adddedProduct,
  removeProduct,
  entityType,
  setEntityType,
}) {
  const navigate = useNavigate();
  const [axiosInstance] = axiosinstances();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const token = JSON.parse(sessionStorage.getItem("token"));
  const requesterId = useSelector(
    (state) => state.selectedretailerReqesterReducer.requesterId
  );
  const unique_id = uuid();
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const handleChangeName = (e, check) => {
    const { name, value } = e.target;
    setName(value);
    const newValues = value.toUpperCase().replace(/ /g, "_");
    setCode(newValues);
  };
  const handleChangeCode = (e) => {
    const { name, value } = e.target;
    const newValues = value.toUpperCase();
    setCode(newValues);
  };
  const navigatetoList = () => {
    navigate("/product-group-list");
  };
  const checkDisable = () => {
    let disable = true;
    if (
      entityType !== "" &&
      name !== "" &&
      code !== "" &&
      Array.isArray(adddedProduct) &&
      adddedProduct.length > 0
    ) {
      disable = false;
    }
    return disable;
  };
  const date = new Date();
  const createProductPrice = async () => {
    let productDetails = {
      header: {
        msgType: "CREATE_PRICING_GROUP",
        service: "PRICING",
        channel: "ADMIN",
        requesterId: requesterId,
        requestId: unique_id,
        time: date,
      },
      details: {
        code: code,
        name: name,
        logo: "",
      },
      pricingIds: [...adddedProduct],
      entityType: entityType,
      actionBy: id,
      reason: "added from admin portal",
    };
    const url = `/api/v1/pricing/group/create`;
    const response = await axiosInstance
      .post(
        url,
        {
          ...productDetails,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("user created res-->", res);
        if (res.status == 200) {
          navigatetoList();
        }
      })
      .catch((err) => {
        //console.log(err);
      });
    return false;
  };
  return (
    <div class="col-12 col-md-6 col-lg-7 col-xl-7">
      <div class="card">
        <div class="addnewproduct">
          <div class="cardheader">
            <h3>Create Product Group</h3>
          </div>
          <div class="row">
            <div class="col-12 mb-2">
              <div class="form-floating">
                <select
                  class="form-select"
                  id="entityType"
                  onChange={(e) => setEntityType(e.target.value)}
                  name="entityType"
                  value={entityType}
                >
                  <option value="">Select</option>
                  <option value="CUSTOMER">CUSTOMER</option>
                  <option value="SUPPLIER">SUPPLIER</option>
                  <option value="RETAILER">RETAILER</option>

                  <option value="DISTRIBUTOR">DISTRIBUTOR</option>
                  <option value="PARTNER">PARTNER</option>
                  <option value="CORPORATE">CORPORATE</option>

                  <option value="WHITELABEL">WHITELABEL</option>
                  <option value="HO">HO</option>
                </select>
                <label for="entityType">Entity Type</label>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  id="RetailerID"
                  placeholder="Enter Product Group Name"
                  name="name"
                  value={name}
                  onChange={(e) => handleChangeName(e, "name")}
                />
                <label for="RetailerID">Product Group Name</label>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-2">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control"
                  id="RetailerID"
                  placeholder="Enter Product Group Code"
                  name="code"
                  value={code}
                  onChange={(e) => handleChangeCode(e, "code")}
                />
                <label for="RetailerID">Product Group Code</label>
              </div>
            </div>

            <div class="col-12">
              <label class="rolbl">Added Products - (36)</label>
              <div class="selectedro">
                {Array.isArray(adddedProduct) &&
                  adddedProduct.map((pro, ind) => {
                    return (
                      <div class="rolist">
                        {pro}{" "}
                        <button
                          class="remove"
                          onClick={() => removeProduct(pro)}
                        ></button>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* <div class="col-12">
								<div class="md-form">
								  <input type="text" id="cl" class="form-control"/>
								  <label for="cl">Category label</label>
								</div>										
							</div> */}

            <div class="col-12 col-sm-7">
              <button
                type="button"
                class="btn btn-primary"
                disabled={checkDisable()}
                onClick={() => createProductPrice()}
              >
                Create Now
              </button>
            </div>

            {/* <div class="col-12 col-sm-5">
								<div class="textlink"><a href="#" data-toggle="modal" data-target="#prohistory">History of changes</a></div>
							</div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
